module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/zh-hant_2-922ffb47eee86bec3f07ce251572ea3f.jpg";